import * as React from "react";
import { singleton } from "logic/singleton";
import ColorMapper from "views/components/visualizations/ColorMapper";
const ChartColorContext = React.createContext({
  colors: ColorMapper.create(),
  setColor: () => Promise.resolve([])
});
export default singleton("views.components.visualizations.ChartColorContext", () => ChartColorContext);
